import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { companyProfileAPIUrls } from '../data';
import { CompanyProfile } from '../types';

type Response = {
  success: boolean;
  message: string;
  data: CompanyProfile;
};

type Return = CompanyProfile;

export type GetCompanyProfile = {
  response: Response;
  return: Return;
};

export const getCompanyProfile = withLogger(async (): Promise<Return> => {
  const url = companyProfileAPIUrls.fetch;

  const {
    data: { data },
  } = await authServiceAxiosClient.get<Response>(url);

  return data;
});
